export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface MangaTag {
  id: string;
  name: string;
}

export interface MangaItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: '韩漫' | '日漫' | '国漫';
  status: '连载中' | '已完结';
  description: string;
  longDescription: string;
  rating: number;
  views: number;
  updateDate: string;
  tags: MangaTag[];
  chapters: MangaChapter[];
  isHot: boolean;
  isNew: boolean;
}

export const mangaTags: MangaTag[] = [
  { id: 't1', name: '恋爱' },
  { id: 't2', name: '奇幻' },
  { id: 't3', name: '冒险' },
  { id: 't4', name: '搞笑' },
  { id: 't5', name: '悬疑' },
  { id: 't6', name: '热血' },
  { id: 't7', name: '都市' },
  { id: 't8', name: '穿越' },
  { id: 't9', name: '后宫' },
  { id: 't10', name: '武侠' },
  { id: 't11', name: '科幻' },
  { id: 't12', name: '恐怖' },
  { id: 't13', name: '校园' },
  { id: 't14', name: '职场' },
  { id: 't15', name: '古风' },
];

function generateChapters(baseId: string, count: number, prefix: string): MangaChapter[] {
  const chapters: MangaChapter[] = [];
  for (let i = count; i >= 1; i--) {
    const date = new Date(2026, 6, 1);
    date.setDate(date.getDate() - (count - i) * 7);
    chapters.push({
      id: `${baseId}-ch-${i}`,
      title: `第${i}话 ${prefix}`,
      number: i,
      updateDate: date.toISOString().split('T')[0],
    });
  }
  return chapters;
}

export const mangaList: MangaItem[] = [
  {
    id: 'm1',
    title: '我的野蛮王妃',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20illustration%2C%20beautiful%20princess%20in%20traditional%20hanbok%20with%20modern%20twist%2C%20soft%20watercolor%20style%2C%20warm%20pink%20cherry%20blossom%20petals%2C%20elegant%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20manga%20style%20character%20design&width=400&height=560&seq=manga-kr-01&orientation=portrait',
    category: '韩漫',
    status: '连载中',
    description: '现代女孩意外穿越到古代朝鲜王朝，成为王世子妃。面对宫廷的明争暗斗与世子的冷漠，她该如何在异世界中生存？',
    longDescription: '二十一世纪的普通大学生林晓月，在一次意外中穿越到了古代朝鲜王朝。醒来时发现自己成为了当朝王世子妃——一个在历史上只活了二十岁的悲剧人物。面对世子的冷漠、后宫嫔妃的排挤以及朝堂上的暗流涌动，她决定要改变自己的命运。凭借现代人的智慧与见识，她逐渐赢得了世子的真心，也在宫廷中站稳了脚跟。然而，历史的车轮真的能被改变吗？一段跨越时空的爱恋就此展开……',
    rating: 9.4,
    views: 1250000,
    updateDate: '2026-08-03',
    tags: [{ id: 't1', name: '恋爱' }, { id: 't8', name: '穿越' }, { id: 't15', name: '古风' }],
    chapters: generateChapters('m1', 68, '命运的齿轮'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm2',
    title: '暗黑之城',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%20art%2C%20mysterious%20city%20skyline%20at%20night%20with%20neon%20glow%2C%20shadowy%20figure%20silhouette%2C%20cyberpunk%20aesthetic%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20clean%20composition%2C%20manga%20art%20style&width=400&height=560&seq=manga-kr-02&orientation=portrait',
    category: '韩漫',
    status: '连载中',
    description: '一座被黑暗势力控制的城市中，拥有特殊能力的少年少女们组成了反抗组织。他们能否打破黑暗，迎来光明？',
    longDescription: '在不远的未来，首尔变成了一座被巨型企业"暗影集团"控制的城市。少数觉醒者拥有超越常人的特殊能力，却被视为威胁而遭到追捕。高中生韩宇在偶然间发现自己也觉醒了能力，并加入了一个秘密反抗组织。在这里，他遇到了形形色色的同伴——控制火焰的少女、操纵时间的青年、预知未来的老人。他们共同对抗暗影集团的压迫，揭开这座城市背后隐藏的惊天秘密……',
    rating: 9.1,
    views: 980000,
    updateDate: '2026-08-02',
    tags: [{ id: 't6', name: '热血' }, { id: 't11', name: '科幻' }, { id: 't2', name: '奇幻' }],
    chapters: generateChapters('m2', 52, '觉醒之日'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm3',
    title: '社长的小秘书',
    author: '朴恩熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%20art%2C%20stylish%20businesswoman%20and%20handsome%20CEO%20in%20modern%20office%20setting%2C%20warm%20lighting%2C%20clean%20minimalist%20style%2C%20professional%20yet%20romantic%20vibe%2C%20soft%20colors%2C%20manga%20illustration&width=400&height=560&seq=manga-kr-03&orientation=portrait',
    category: '韩漫',
    status: '连载中',
    description: '刚毕业的职场新人意外成为冷面社长的私人秘书。从最初的针锋相对到渐渐心动，一段办公室恋情悄然展开。',
    longDescription: '应届毕业生崔秀雅好不容易进入了大企业"世宗集团"，却没想到被分派给了公司里最难伺候的人——社长姜泰俊做私人秘书。冷面上司的严苛要求让她吃尽苦头，但随着时间的推移，她发现这位看似冷酷的社长背后有着不为人知的温柔一面。而姜泰俊也被这位倔强又善良的秘书渐渐吸引。然而，职场恋情的道路并不平坦，同事的嫉妒、商业对手的阴谋，都在考验着两人的感情……',
    rating: 8.9,
    views: 1560000,
    updateDate: '2026-08-03',
    tags: [{ id: 't1', name: '恋爱' }, { id: 't7', name: '都市' }, { id: 't14', name: '职场' }],
    chapters: generateChapters('m3', 75, '秘书的日常'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm4',
    title: '剑道至尊',
    author: '崔勇俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20art%2C%20swordsman%20in%20traditional%20Korean%20warrior%20attire%20with%20glowing%20sword%2C%20epic%20dramatic%20lighting%2C%20ancient%20Korean%20palace%20background%2C%20dynamic%20composition%2C%20manga%20style%20action%20illustration&width=400&height=560&seq=manga-kr-04&orientation=portrait',
    category: '韩漫',
    status: '已完结',
    description: '被灭门的天才剑客重生回到少年时代，带着前世记忆的他决心重写命运，踏上剑道巅峰。',
    longDescription: '一代剑尊李青云在飞升之际遭到挚友背叛，含恨而终。然而命运给了他一次重来的机会——他重生回到了少年时代，回到了家族被灭门的前一年。带着前世的记忆与剑道感悟，李青云开始布局，不仅要保护家人，更要揭开那场灭门惨案背后的惊天阴谋。从一个小小的武馆学徒，到名震天下的剑道至尊，他的传奇，才刚刚开始……',
    rating: 9.3,
    views: 2100000,
    updateDate: '2026-06-15',
    tags: [{ id: 't6', name: '热血' }, { id: 't8', name: '穿越' }, { id: 't10', name: '武侠' }],
    chapters: generateChapters('m4', 120, '剑道之路'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm5',
    title: '甜蜜的陷阱',
    author: '尹素拉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sweet%20romance%20manhwa%20cover%2C%20cute%20couple%20in%20cozy%20cafe%20setting%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20desserts%20and%20flowers%2C%20warm%20soft%20lighting%2C%20clean%20cute%20manga%20illustration%20style&width=400&height=560&seq=manga-kr-05&orientation=portrait',
    category: '韩漫',
    status: '连载中',
    description: '甜品师与美食评论家之间的甜蜜故事。她做的每一道甜品都是对他的"甜蜜陷阱"。',
    longDescription: '首尔小巷深处有一家小小的甜品店"甜蜜时光"，店主韩多温是一位天赋异禀的甜品师。某天，一位神秘的美食评论家突然到访，对她的甜品提出了尖锐的批评。不服气的韩多温决定用一道又一道精心制作的甜品来征服这位挑剔的评论家。在这个过程中，她不知道对方已经悄然陷入了她用甜蜜编织的"陷阱"之中……一段以甜品为媒介的美好爱情故事，甜度满分！',
    rating: 8.7,
    views: 890000,
    updateDate: '2026-08-01',
    tags: [{ id: 't1', name: '恋爱' }, { id: 't7', name: '都市' }, { id: 't4', name: '搞笑' }],
    chapters: generateChapters('m5', 45, '甜蜜配方'),
    isHot: false,
    isNew: true,
  },
  {
    id: 'm6',
    title: '进击的巨人',
    author: '谏山创',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%20art%2C%20colossal%20titan%20looming%20over%20massive%20wall%2C%20survey%20corps%20soldiers%20with%20vertical%20maneuvering%20gear%2C%20dramatic%20epic%20atmosphere%2C%20clean%20manga%20style%20illustration%2C%20dynamic%20action%20scene&width=400&height=560&seq=manga-jp-01&orientation=portrait',
    category: '日漫',
    status: '已完结',
    description: '人类被巨人逼入高墙之内生存，少年艾伦·耶格尔目睹母亲被巨人吞噬，发誓要消灭所有巨人。',
    longDescription: '在一个被巨人支配的世界里，人类被迫生活在由三道巨大围墙保护的城市中。少年艾伦·耶格尔在亲眼目睹母亲被巨人吞噬后，立誓要将所有巨人驱逐出去。他加入了调查兵团，与同伴三笠、阿尔敏一起，踏上了与巨人战斗的残酷征程。随着故事深入，关于巨人、墙壁以及这个世界的真相逐渐浮出水面，远比任何人想象的都要震撼……这部史诗级的作品探讨了自由、牺牲与人性的深刻主题。',
    rating: 9.6,
    views: 3500000,
    updateDate: '2025-04-09',
    tags: [{ id: 't6', name: '热血' }, { id: 't12', name: '恐怖' }, { id: 't2', name: '奇幻' }],
    chapters: generateChapters('m6', 139, '自由之翼'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm7',
    title: '咒术回战',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20supernatural%20battle%20manga%20cover%2C%20sorcerer%20student%20with%20dark%20energy%20surrounding%2C%20cursed%20spirits%20in%20background%2C%20dynamic%20action%20pose%2C%20modern%20urban%20setting%2C%20clean%20manga%20art%20style%2C%20dramatic%20lighting&width=400&height=560&seq=manga-jp-02&orientation=portrait',
    category: '日漫',
    status: '连载中',
    description: '高中生虎杖悠仁吞下诅咒之王的手指后，成为宿傩的容器，从此踏入了咒术师的世界。',
    longDescription: '拥有超乎常人体能的普通高中生虎杖悠仁，为了拯救被诅咒袭击的学长学姐，吞下了特级咒物——诅咒之王两面宿傩的手指，成为了宿傩的容器。从此，他的人生发生了翻天覆地的变化。进入东京都立咒术高等专门学校后，虎杖与伏黑惠、钉崎野蔷薇等伙伴一起，作为咒术师与诅咒战斗。但体内宿傩的存在，始终是一颗随时可能引爆的定时炸弹……',
    rating: 9.2,
    views: 2800000,
    updateDate: '2026-08-03',
    tags: [{ id: 't6', name: '热血' }, { id: 't2', name: '奇幻' }, { id: 't12', name: '恐怖' }],
    chapters: generateChapters('m7', 260, '咒术高专'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm8',
    title: '间谍过家家',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20comedy%20spy%20family%20manga%20cover%2C%20elegant%20family%20of%20three%20in%20stylish%20outfits%2C%20spy%20assassin%20and%20telepath%20girl%2C%20warm%20humorous%20vibe%2C%20retro%20European%20setting%2C%20clean%20manga%20illustration%2C%20pastel%20color%20palette&width=400&height=560&seq=manga-jp-03&orientation=portrait',
    category: '日漫',
    status: '连载中',
    description: '间谍父亲、杀手母亲、超能力女儿——这个虚假家庭为了各自的目的走到一起，却收获了最真挚的亲情。',
    longDescription: '为了执行维护和平的秘密任务，西国最强间谍"黄昏"需要在一周内组建一个临时家庭。他收养了能读心的超能力少女阿尼亚，又与身份神秘的市政府职员约尔假结婚。然而他不知道的是——妻子约尔其实是代号"睡美人"的致命杀手。三人各怀秘密，却在这个虚假的家庭中找到了真正的温暖。当世界和平的重担落在这个"临时家庭"肩上时，一场笑中带泪的喜剧就此展开！',
    rating: 9.5,
    views: 2200000,
    updateDate: '2026-08-02',
    tags: [{ id: 't4', name: '搞笑' }, { id: 't7', name: '都市' }, { id: 't3', name: '冒险' }],
    chapters: generateChapters('m8', 98, '家庭任务'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm9',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20manga%20cover%20art%2C%20young%20swordsman%20with%20nichirin%20katana%2C%20water%20breathing%20visual%20effects%2C%20traditional%20Japanese%20Taisho%20era%20aesthetic%2C%20snowy%20mountain%20background%2C%20dynamic%20manga%20illustration%2C%20warm%20earthy%20tones&width=400&height=560&seq=manga-jp-04&orientation=portrait',
    category: '日漫',
    status: '已完结',
    description: '家人被鬼杀害、妹妹变为鬼的少年灶门炭治郎，踏上斩鬼之旅，寻找让妹妹恢复为人类的方法。',
    longDescription: '大正时代的日本，少年灶门炭治郎一家惨遭恶鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。但祢豆子仍保留着人类的情感，没有完全丧失理智。为了寻找让妹妹恢复为人类的方法，炭治郎踏上了成为"鬼杀队"剑士的道路。在鳞泷左近次的指导下，他掌握了"水之呼吸"剑术，与伙伴我妻善逸、嘴平伊之助一起，面对一个又一个强大的鬼，最终将目光投向了一切悲剧的源头——鬼舞辻无惨……',
    rating: 9.5,
    views: 3200000,
    updateDate: '2024-05-18',
    tags: [{ id: 't6', name: '热血' }, { id: 't12', name: '恐怖' }, { id: 't15', name: '古风' }],
    chapters: generateChapters('m9', 205, '鬼杀之刃'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm10',
    title: '葬送的芙莉莲',
    author: '山田钟人',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20manga%20cover%2C%20elf%20mage%20girl%20with%20staff%20walking%20through%20flower%20field%2C%20nostalgic%20melancholic%20atmosphere%2C%20soft%20watercolor%20style%2C%20medieval%20fantasy%20setting%2C%20clean%20beautiful%20manga%20illustration%2C%20warm%20golden%20light&width=400&height=560&seq=manga-jp-05&orientation=portrait',
    category: '日漫',
    status: '连载中',
    description: '勇者一行打败魔王后，精灵魔法师芙莉莲踏上了理解人类情感的旅途，重温与昔日的同伴们度过的时光。',
    longDescription: '魔法师芙莉莲是打败魔王的勇者小队中的一员，身为精灵的她拥有近乎永恒的生命。在勇者辛美尔去世后，她才意识到自己对这位同伴了解得太少。为了真正理解人类的情感和生命的意义，芙莉莲踏上了新的旅程，带着新的伙伴重走当年勇者一行的道路。在这趟旅途中，那些曾经的记忆片段逐渐拼凑成一幅完整的画卷，关于友情、爱与离别……这是一部关于"之后"的故事，温柔而深沉。',
    rating: 9.4,
    views: 1800000,
    updateDate: '2026-08-01',
    tags: [{ id: 't2', name: '奇幻' }, { id: 't3', name: '冒险' }, { id: 't15', name: '古风' }],
    chapters: generateChapters('m10', 135, '旅途的回忆'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm11',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20modern%20manhua%20cover%2C%20young%20man%20with%20mysterious%20energy%20powers%2C%20traditional%20Taoist%20elements%2C%20urban%20Chinese%20city%20background%2C%20dynamic%20action%20pose%2C%20clean%20manhua%20art%20style%2C%20warm%20dramatic%20lighting&width=400&height=560&seq=manga-cn-01&orientation=portrait',
    category: '国漫',
    status: '连载中',
    description: '普通大学生张楚岚因爷爷的坟墓被撬而卷入异人世界，一段关于道法、江湖与成长的冒险就此展开。',
    longDescription: '平凡的大学生张楚岚原本想过着普通的生活，直到爷爷的坟墓被人盗掘，一个名为"哪都通"的神秘组织找上了他。张楚岚这才知道，自己出生于异人世家，体内流淌着特殊的血脉。为了查明爷爷之死的真相，张楚岚加入了"哪都通"快递公司（实为异人管理机构），结识了不老少女冯宝宝、武当山道士王也等一众奇人异士。在这个隐藏于现代社会之下的异人世界中，道家秘术、武术传承、江湖恩怨交织在一起，一段波澜壮阔的传奇故事徐徐展开……',
    rating: 9.3,
    views: 2800000,
    updateDate: '2026-08-03',
    tags: [{ id: 't6', name: '热血' }, { id: 't2', name: '奇幻' }, { id: 't10', name: '武侠' }],
    chapters: generateChapters('m11', 620, '异人之旅'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm12',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20fantasy%20manhua%20cover%2C%20beautiful%20fox%20spirit%20girl%20in%20traditional%20red%20Chinese%20dress%2C%20cherry%20blossom%20petals%2C%20ancient%20Chinese%20architecture%2C%20soft%20romantic%20atmosphere%2C%20clean%20manhua%20illustration%2C%20warm%20pink%20tones&width=400&height=560&seq=manga-cn-02&orientation=portrait',
    category: '国漫',
    status: '连载中',
    description: '以红线仙涂山苏苏为主角，讲述人与妖之间的前世今生的爱情故事。',
    longDescription: '在人妖共存的奇幻世界中，有一群被称为"红线仙"的狐妖，她们专门为人与妖牵起姻缘红线。迷糊可爱的小狐妖涂山苏苏立志成为一名优秀的红线仙，在一次任务中结识了道士白月初。两人在完成一个个姻缘委托的过程中，逐渐发现了彼此之间跨越千年的羁绊。每一段姻缘背后，都藏着一个感人至深的前世今生的故事。欢笑与泪水交织，这部作品重新定义了"缘分"的意义……',
    rating: 9.1,
    views: 1950000,
    updateDate: '2026-08-02',
    tags: [{ id: 't1', name: '恋爱' }, { id: 't2', name: '奇幻' }, { id: 't15', name: '古风' }],
    chapters: generateChapters('m12', 520, '红线之约'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm13',
    title: '斗破苍穹',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%2C%20young%20warrior%20with%20flame%20energy%20surrounding%2C%20epic%20fantasy%20landscape%2C%20giant%20sword%2C%20dramatic%20dynamic%20composition%2C%20clean%20manhua%20art%20style%2C%20warm%20fiery%20color%20palette&width=400&height=560&seq=manga-cn-03&orientation=portrait',
    category: '国漫',
    status: '已完结',
    description: '天才少年萧炎在失去了所有修为后，在戒指中发现了药尘的秘密，从此踏上重回巅峰的修炼之路。',
    longDescription: '萧炎，曾经的修炼天才，却在十二岁那年突然失去了所有修为，沦为废柴，受尽冷眼与嘲讽。就在他人生最低谷的时候，机缘巧合之下，他发现自己佩戴的戒指中竟然寄宿着一位强大的灵魂——药老！在药老的指导下，萧炎重新踏上修炼之路。炼丹、斗技、异火——一个波澜壮阔的斗气大陆在他面前展开。从乌坦城到中州大陆，从斗者到斗帝，萧炎用自己的努力与汗水，书写了一段震撼整个大陆的传奇！',
    rating: 9.0,
    views: 4500000,
    updateDate: '2025-12-20',
    tags: [{ id: 't6', name: '热血' }, { id: 't2', name: '奇幻' }, { id: 't10', name: '武侠' }],
    chapters: generateChapters('m13', 510, '斗气之路'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm14',
    title: '全职高手',
    author: '蝴蝶蓝',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20gaming%20manhua%20cover%2C%20professional%20gamer%20with%20headset%20in%20cyber%20arena%2C%20game%20character%20silhouette%20behind%2C%20futuristic%20neon%20lighting%2C%20dynamic%20competitive%20atmosphere%2C%20clean%20manhua%20illustration%20style&width=400&height=560&seq=manga-cn-04&orientation=portrait',
    category: '国漫',
    status: '已完结',
    description: '被俱乐部驱逐的电竞顶级高手叶修，在网吧重新开始，组建新的战队，重回荣耀巅峰。',
    longDescription: '荣耀，一款风靡全球的电子竞技游戏。叶修，荣耀职业联赛的开荒一代，被誉为"斗神"的顶级高手。然而，由于种种原因，他被自己一手创建的俱乐部"嘉世"驱逐。失去了荣耀账号和职业选手身份后，他来到一家网吧当起了网管。但叶修从未放弃——他重新注册了一个名为"君莫笑"的新账号，从零开始冲击荣耀之巅。在网吧里，他结识了一群志同道合的伙伴，组建了新的战队"兴欣"。面对昔日队友的质疑、对手的挑战，叶修将用实力证明——全职高手，不曾离开！',
    rating: 9.3,
    views: 3100000,
    updateDate: '2025-08-15',
    tags: [{ id: 't6', name: '热血' }, { id: 't7', name: '都市' }, { id: 't11', name: '科幻' }],
    chapters: generateChapters('m14', 325, '荣耀之路'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm15',
    title: '绝世唐门',
    author: '唐家三少',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20martial%20arts%20manhua%20cover%2C%20young%20soul%20master%20with%20spirit%20ring%20effects%2C%20magical%20academy%20background%2C%20ancient%20Chinese%20architecture%2C%20mystical%20glowing%20atmosphere%2C%20clean%20manhua%20illustration%2C%20warm%20golden%20light&width=400&height=560&seq=manga-cn-05&orientation=portrait',
    category: '国漫',
    status: '连载中',
    description: '少年霍雨浩在母亲去世后独自踏上修炼之路，进入史莱克学院，在斗罗大陆上书写属于自己的传奇。',
    longDescription: '斗罗大陆一万年后，曾经辉煌的唐门已经没落。少年霍雨浩自幼丧母，在白虎公爵府受尽欺凌。但他从未放弃——凭借着母亲留给他的遗物和自身的努力，他进入了大陆第一学院"史莱克学院"。在这里，他觉醒了罕见的精神系武魂"灵眸"，结识了命中注定的伙伴们。从学院新人到大陆强者，霍雨浩在一步步的成长中，也渐渐揭开了隐藏在斗罗大陆背后的惊天秘密……',
    rating: 8.8,
    views: 2200000,
    updateDate: '2026-07-28',
    tags: [{ id: 't2', name: '奇幻' }, { id: 't3', name: '冒险' }, { id: 't1', name: '恋爱' }],
    chapters: generateChapters('m15', 350, '唐门崛起'),
    isHot: false,
    isNew: true,
  },
  {
    id: 'm16',
    title: '武动乾坤',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%2C%20martial%20artist%20meditating%20with%20mystical%20energy%20flowing%2C%20ancient%20Chinese%20mountain%20landscape%2C%20dramatic%20golden%20and%20warm%20tones%2C%20clean%20manhua%20illustration%2C%20epic%20fantasy%20atmosphere&width=400&height=560&seq=manga-cn-06&orientation=portrait',
    category: '国漫',
    status: '已完结',
    description: '林动在大炎王朝天都郡青阳镇的一个不起眼的林家分家中崛起，开始了逆袭之路。',
    longDescription: '大炎王朝，青阳镇，林动出身于林家分家，在家族中地位卑微。一次偶然的机会，他在山洞中发现了一枚神秘的石符，从此人生彻底改变。石符中蕴含着远古的秘密和强大的力量，帮助他在武道之路上突飞猛进。从青阳镇到大炎王朝，从百朝大战到域外世界，林动用实力一步步走向武道巅峰，成为了天地间最强的武祖！',
    rating: 8.7,
    views: 2800000,
    updateDate: '2025-10-30',
    tags: [{ id: 't6', name: '热血' }, { id: 't2', name: '奇幻' }, { id: 't10', name: '武侠' }],
    chapters: generateChapters('m16', 380, '武道乾坤'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm17',
    title: '女神降临',
    author: '猫咪',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20beauty%20makeup%20romance%20manhwa%20cover%2C%20transformation%20of%20ordinary%20girl%20to%20beautiful%20goddess%2C%20makeup%20tools%20and%20cosmetics%2C%20school%20setting%2C%20bright%20warm%20lighting%2C%20clean%20manga%20style%2C%20pastel%20pink%20tones&width=400&height=560&seq=manga-kr-06&orientation=portrait',
    category: '韩漫',
    status: '已完结',
    description: '因为长相被欺负的女孩通过化妆变身校园女神，在双重身份中收获了友情与爱情。',
    longDescription: '林珠京从小因为长相平凡而被同学欺负，在高中时期通过自学化妆技巧，实现了惊人的转变。凭借精湛的化妆技术，她成为了校园里的人气女神。但隐藏真实容貌的生活并不轻松——她每天都要比任何人都早到学校化妆，比任何人都晚离开。当两个完全不同类型的男生先后发现了她的秘密，一段关于容貌、自信与真爱的青春故事就此展开……',
    rating: 8.5,
    views: 3400000,
    updateDate: '2025-05-10',
    tags: [{ id: 't1', name: '恋爱' }, { id: 't13', name: '校园' }, { id: 't7', name: '都市' }],
    chapters: generateChapters('m17', 222, '化妆魔法'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm18',
    title: '我独自升级',
    author: 'Chugong',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20manhwa%20cover%2C%20shadow%20monarch%20with%20dark%20purple%20energy%20and%20shadow%20army%2C%20dungeon%20hunter%20theme%2C%20cool%20dark%20aesthetic%2C%20clean%20manhwa%20illustration%2C%20dramatic%20lighting%2C%20epic%20composition&width=400&height=560&seq=manga-kr-07&orientation=portrait',
    category: '韩漫',
    status: '已完结',
    description: '被称为"人类最弱兵器"的E级猎人成振宇，在一次濒死体验后获得了可以无限升级的独特能力。',
    longDescription: '在一个连接异次元的"门"不断出现的世界里，被称为"猎人"的觉醒者们对抗着来自门后的怪物。成振宇是猎人中最弱的E级——被嘲笑为"人类最弱兵器"。在一次几乎全军覆没的S级地下城任务中，成振宇为了保护队友选择牺牲自己。就在死亡降临的那一刻，一个神秘的系统窗口出现在他面前——"玩家已满足隐藏条件，系统已激活。"从此，成振宇成为了唯一能够通过任务无限升级的猎人，从最弱到最强，他的征程正式开始！',
    rating: 9.4,
    views: 4200000,
    updateDate: '2025-12-25',
    tags: [{ id: 't6', name: '热血' }, { id: 't2', name: '奇幻' }, { id: 't11', name: '科幻' }],
    chapters: generateChapters('m18', 200, '暗影君主'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm19',
    title: '电锯人',
    author: '藤本树',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20chainsaw%20man%20manga%20cover%2C%20man%20with%20chainsaw%20arms%20and%20head%2C%20blood%20splatter%20visual%20effects%2C%20urban%20Japanese%20city%20background%2C%20chaotic%20dark%20aesthetic%2C%20clean%20manga%20illustration%2C%20warm%20dramatic%20lighting&width=400&height=560&seq=manga-jp-06&orientation=portrait',
    category: '日漫',
    status: '连载中',
    description: '贫穷少年淀治与恶魔啵奇塔融合成为"电锯人"，加入公安对魔特异课，与恶魔战斗。',
    longDescription: '背负着父亲留下巨额债务的少年淀治，与宠物恶魔啵奇塔一起依靠猎杀恶魔勉强维生。然而在一次任务中，他被雇主出卖，被恶魔杀死并分尸。啵奇塔在最后关头与他融合，赋予了他变身"电锯人"的能力。重生后的淀治被公安对魔特异课的玛奇玛收编，开始作为恶魔猎人与同伴们并肩作战。但在这个恶魔横行的世界里，真正的敌人究竟是谁？一部疯狂、自由、充满冲击力的邪道漫画！',
    rating: 9.0,
    views: 2600000,
    updateDate: '2026-07-30',
    tags: [{ id: 't6', name: '热血' }, { id: 't12', name: '恐怖' }, { id: 't5', name: '悬疑' }],
    chapters: generateChapters('m19', 175, '链锯轰鸣'),
    isHot: true,
    isNew: false,
  },
  {
    id: 'm20',
    title: '星梦偶像计划',
    author: '林欣',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20idol%20trainee%20manhua%20cover%2C%20young%20girl%20in%20sparkling%20stage%20outfit%2C%20spotlight%20and%20stage%20effects%2C%20dreamy%20atmosphere%2C%20star%20glitter%2C%20clean%20manhua%20illustration%2C%20warm%20pink%20and%20gold%20tones&width=400&height=560&seq=manga-cn-07&orientation=portrait',
    category: '国漫',
    status: '连载中',
    description: '普通女孩苏星梦参加偶像选秀节目，从练习生一步步成长为闪耀舞台的超级偶像。',
    longDescription: '热爱唱歌跳舞的普通女孩苏星梦，在一次偶然的机会下参加了全国最大的偶像选秀节目《星光大道》。从万人海选中脱颖而出，进入封闭式训练营。在这条追梦的道路上，她不仅要面对严苛的训练、残酷的淘汰赛制，还要应对来自其他练习生的竞争与友谊。从最初的青涩胆怯，到一步步在舞台上绽放光芒，苏星梦用自己的努力和真诚赢得了粉丝的心，也收获了珍贵的友情与朦胧的爱情……',
    rating: 8.6,
    views: 1650000,
    updateDate: '2026-08-01',
    tags: [{ id: 't13', name: '校园' }, { id: 't7', name: '都市' }, { id: 't1', name: '恋爱' }],
    chapters: generateChapters('m20', 86, '星光闪耀'),
    isHot: false,
    isNew: true,
  },
  {
    id: 'm21',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20tower%20manhwa%20cover%2C%20mysterious%20tall%20tower%20reaching%20sky%2C%20young%20boy%20climbing%20with%20determination%2C%20mystical%20atmosphere%2C%20cosmic%20background%2C%20clean%20manhwa%20illustration%2C%20warm%20mysterious%20light&width=400&height=560&seq=manga-kr-08&orientation=portrait',
    category: '韩漫',
    status: '连载中',
    description: '少年二十五夜为了追寻唯一的朋友蕾哈尔，进入了传说中的神之塔，踏上试炼之路。',
    longDescription: '传说中，登上神之塔的顶端就能获得整个世界。少年二十五夜一直生活在塔底黑暗的洞穴中，他唯一的朋友和光芒就是少女蕾哈尔。当蕾哈尔决定踏入神之塔追寻星空时，二十五夜毫不犹豫地追随她进入了这座神秘的塔。在塔中，每一层都是一个独立的世界，登塔者必须通过各种严苛的试炼。二十五夜在试炼中不断成长，结识了众多伙伴和对手，也逐渐发现了隐藏在神之塔背后的惊天秘密……',
    rating: 9.2,
    views: 1950000,
    updateDate: '2026-08-03',
    tags: [{ id: 't2', name: '奇幻' }, { id: 't3', name: '冒险' }, { id: 't5', name: '悬疑' }],
    chapters: generateChapters('m21', 580, '登塔试炼'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm22',
    title: '镖人',
    author: '许先哲',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20manhua%20cover%2C%20lone%20swordsman%20in%20desert%20landscape%2C%20ancient%20Chinese%20%E9%9A%8B%E6%9C%9D%20setting%2C%20gritty%20realistic%20style%2C%20dusty%20warm%20tones%2C%20clean%20manhua%20illustration%2C%20dynamic%20action%20vibe&width=400&height=560&seq=manga-cn-08&orientation=portrait',
    category: '国漫',
    status: '连载中',
    description: '隋末乱世，身手不凡的镖客刀马行走于大漠与江湖之间，一段惊心动魄的护镖之旅。',
    longDescription: '大业三年，隋炀帝暴政，天下大乱。身手不凡的镖客刀马带着孩子小七，行走于西域大漠与中原江湖之间，以护镖为生。在一次看似普通的护镖任务中，刀马卷入了一场涉及朝廷、江湖与西域各方势力的惊天阴谋。刀光剑影中，刀马凭借过人的身手与智慧，在乱世中杀出一条血路。而他随身保护的那个神秘镖箱，也隐藏着可能改变天下格局的秘密。一部国漫硬派武侠的巅峰之作！',
    rating: 9.5,
    views: 1500000,
    updateDate: '2026-07-25',
    tags: [{ id: 't10', name: '武侠' }, { id: 't15', name: '古风' }, { id: 't6', name: '热血' }],
    chapters: generateChapters('m22', 120, '大漠刀客'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm23',
    title: '排球少年',
    author: '古馆春一',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20volleyball%20manga%20cover%2C%20high%20school%20volleyball%20team%20in%20action%2C%20dynamic%20jump%20and%20spike%20pose%2C%20gymnasium%20setting%2C%20energetic%20sports%20atmosphere%2C%20clean%20manga%20illustration%2C%20warm%20motivational%20tone&width=400&height=560&seq=manga-jp-07&orientation=portrait',
    category: '日漫',
    status: '已完结',
    description: '身材矮小的日向翔阳凭着对排球的热爱，考入乌野高中，与天才二传手影山飞雄成为搭档。',
    longDescription: '初中时在电视上看到"小巨人"的英姿后，日向翔阳便对排球产生了无限的热爱。尽管身材矮小，但他凭着超强的弹跳力和永不放弃的精神，在初中最后一场正式比赛中展现了自己的实力。进入乌野高中后，他遇到了曾经在赛场上击败自己的天才二传手——影山飞雄。两个性格迥异的天才从最初的针锋相对，到成为赛场上最默契的搭档。他们与乌野高中排球部的伙伴们一起，向着全国大赛的舞台发起冲击——"飞吧！"',
    rating: 9.4,
    views: 2400000,
    updateDate: '2024-07-20',
    tags: [{ id: 't6', name: '热血' }, { id: 't13', name: '校园' }, { id: 't4', name: '搞笑' }],
    chapters: generateChapters('m23', 402, '飞向最高'),
    isHot: false,
    isNew: false,
  },
  {
    id: 'm24',
    title: '看脸时代',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20drama%20manhwa%20cover%2C%20split%20face%20showing%20two%20different%20bodies%2C%20high%20school%20bullying%20theme%2C%20dramatic%20contrast%2C%20clean%20manhwa%20illustration%2C%20warm%20urban%20lighting&width=400&height=560&seq=manga-kr-09&orientation=portrait',
    category: '韩漫',
    status: '连载中',
    description: '因长相被霸凌的男高中生，某天发现自己可以在两个身体之间切换——一个是原来的丑男，一个是完美的帅哥。',
    longDescription: '朴亨硕是一个因为肥胖和丑陋而饱受校园霸凌的高中生。每天在学校里被欺负的他，最终忍无可忍决定转学。就在转学前夕，他醒来时发现自己拥有了一个全新的身体——高大、帅气、完美。更神奇的是，他可以在两个身体之间切换！白天用帅气身体在学校成为人气王，晚上用原来身体打工赚钱。但随着他在新学校的深入，他发现这个表面光鲜的校园背后，隐藏着更加黑暗的霸凌链条……',
    rating: 8.9,
    views: 3800000,
    updateDate: '2026-08-02',
    tags: [{ id: 't13', name: '校园' }, { id: 't7', name: '都市' }, { id: 't5', name: '悬疑' }],
    chapters: generateChapters('m24', 450, '双重人生'),
    isHot: true,
    isNew: false,
  },
];

export const categoryMap = {
  'all': { name: '全部', slug: 'all' },
  '韩漫': { name: '韩漫', slug: 'korean' },
  '日漫': { name: '日漫', slug: 'japanese' },
  '国漫': { name: '国漫', slug: 'chinese' },
};

export function getMangaByCategory(category: string): MangaItem[] {
  if (category === 'all') return mangaList;
  return mangaList.filter((m) => m.category === category);
}

export function getMangaById(id: string): MangaItem | undefined {
  return mangaList.find((m) => m.id === id);
}

export function getHotManga(): MangaItem[] {
  return mangaList.filter((m) => m.isHot);
}

export function getNewManga(): MangaItem[] {
  return mangaList.filter((m) => m.isNew);
}

export function getCompletedManga(): MangaItem[] {
  return mangaList.filter((m) => m.status === '已完结').slice(0, 8);
}

export function getRecommendManga(excludeId?: string): MangaItem[] {
  const filtered = excludeId ? mangaList.filter((m) => m.id !== excludeId) : mangaList;
  return filtered.sort((a, b) => b.rating - a.rating).slice(0, 6);
}

export function getLatestUpdates(): MangaItem[] {
  return [...mangaList].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 10);
}